import React, { useState, useEffect } from 'react';
import { Checkbox, Radio } from "antd";
import { useAssetsGetModel } from "../../assetsGetModel";
import { IPrintProps, YhPrint } from "@/components/YhPrint";
import { assetsGetService } from '../../assetsGetService';
import { ISCMSDcGoodsOne, ISCMAssetsGetDetail } from '../../assetsGetTypes';
import moment from 'moment';
import useGlobalModel from '@/model/globalModel';
import { EquilibriumEnum } from '@/types/AppEnums';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useDictModel } from '@/views/base/dict/dictModel';
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { momentFormat } from '@/utils/utils';

export function Print({ id }: IPrintProps) {
	const { print, setPrint } = useAssetsGetModel();
	const [formVal, setFormVal] = useState<ISCMAssetsGetDetail>();
	const [goodsList, setGoodsList] = useState<ISCMSDcGoodsOne[]>([]);
	const [check, setCheck] = useState<boolean>(false)
	const { user } = useGlobalModel();
    const { getSelectedDictValueOne,getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);
	
	useEffect(() => {
		print && getPoDetailOne()
	}, [print])
    const handlePrintNum = async () => {
        await assetsGetService.print(id);
    }
	//获取一条数据
	const getPoDetailOne = async () => {
		let { retData } = await assetsGetService.one(id);
		let { details, ...formVal } = retData;
		// let newDetails = details.filter(item => !(item.materialCode === EquilibriumEnum.JUST || item.materialCode === EquilibriumEnum.NEGATIVE))
		if (retData) {
			// setGoodsList(details.sort((a: any, b: any) => a.materialCode.localeCompare(b.materialCode, 'zh-Hans-CN', { sensitivity: 'accent' })).sort((a: any, b: any) => a.shelfCode.localeCompare(b.shelfCode, 'zh-Hans-CN', { sensitivity: 'accent' })).map((item, index) => ({ ...item, No: index + 1,typeName:item.typeCode?getTreeNodeName(item.typeCode):'',unitName:item.unitCode?getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find((list) => list.value === item.unitCode)?.label:'' })));
			setGoodsList(details)
			setFormVal({...retData,typeName:getTreeNodeName(retData.typeCode) ?? '',createTime:momentFormat(retData.createTime)});
		}
	};

	const columns = [
		{
			title: '序号',
			dataIndex: 'No',
		},
		{
			title: '物资编码',
			dataIndex: 'materialCode',
		},
		{
			title: '物资名称',
			dataIndex: 'materialName',
		},
		{
			title: '单位',
			dataIndex: 'unitName',
		},
		{
			title: '数量',
			dataIndex: 'num',
		},
		// {
		// 	title: '物资类型',
		// 	dataIndex: 'typeName',
		// },
		{
			title: '单价',
			dataIndex: 'price',
		},
		{
			title: '金额',
			dataIndex: 'amount',
		},
		{
			title: '仓库',
			dataIndex: 'warehouseName',
		},
		{
			title: '货位',
			dataIndex: 'shelfCode',
		},
	]

	//头部与底部展示
	const printShow = {
		header: [
			{
				fieldLabel: "领取单号",
				fieldValue: formVal?.code ?? "",
				// className: "w30"
			},
			// {
			// 	fieldLabel: "用户名称",
			// 	fieldValue: formVal?.supplierName ?? "",
			// 	className: "w20"
			// },
			{
				fieldLabel: "领取部门",
				fieldValue: formVal?.departmentName ?? "",
			},
			{
				fieldLabel: "打印时间",
				fieldValue: moment().format("YYYY-MM-DD HH:mm:ss"), //当前时间
				// className: "w30"
			},
			{
				fieldLabel: "领取公司",
				fieldValue: formVal?.companyName ?? "",
			},
			{
				fieldLabel: "领取类型",
				fieldValue: formVal?.typeName ?? "",
			},
			{
				fieldLabel: "领取日期",
				fieldValue: formVal?.createTime ?? "",
			},
		],
		footer: [
			{
				fieldLabel: "制表人",
				fieldValue: user.userName,
				className: "w20"
			},
			{
				fieldLabel: "领取员",
				fieldValue: formVal?.createUser ?? "",
				className: "w20"
			},
			{
				fieldLabel: "备注",
				fieldValue: formVal?.note ?? "",
				className: "w20"
			},
		],
		totalAmount: [
			// {
			// 	fieldLabel: "合计",
			// 	fieldValue: goodsList.reduce((total, next) => { total += (Number(next?.amount ?? 0)); return total }, 0),
			// },
			// {
			// 	fieldLabel: "优惠金额",
			// 	fieldValue: formVal?.discountTotalAmount,
			// },
			[
				// {
				// 	fieldLabel: "应付金额",
				// 	// fieldValue: formVal?.stockIoTotalAmount,
				// 	fieldValue: formVal?.stockIoTotalAmount,
				// 	RMB: true
				// },
				{
					fieldLabel: "合计",
					// fieldValue: formVal?.stockIoTotalAmount,
					 fieldValue: goodsList.reduce((total, next) => { total += (Number(next?.amount ?? 0)); return total }, 0),
					RMB: true
				},
				{
					fieldLabel: "",
					fieldValue: "",
				}
				],
		]
	}
	// const checkChange = (e: CheckboxChangeEvent) => setCheck(e.target.checked)

	const [paperSize, setPaperSize] = useState<number>(40);  //打印的商品条数
	const modalTitle = <>
		<span style={{ marginRight: "15px" }}>打印详情</span>
		<Radio.Group onChange={(e) => setPaperSize(e.target.value)} value={paperSize}>
			<Radio value={45}>A4</Radio>
			<Radio value={40}>10x11</Radio>
		</Radio.Group>
		<span style={{ marginRight: "30px" }}></span>
		{/* <Checkbox checked={check} onChange={checkChange}>是否显示差额</Checkbox> */}
	</>
	const newGoodsList = check ? goodsList : goodsList.filter(item => !(item.materialCode === EquilibriumEnum.JUST || item.materialCode === EquilibriumEnum.NEGATIVE)).map((item, index) => ({ ...item, No: index + 1 }))
	return (
		<YhPrint
			modalTitle={modalTitle}
			title={formVal?.departmentName ?? "物资"}
			type="领取单"
			visible={print}
			onClose={() => setPrint(false)}
			columns={columns}
			dataSource={newGoodsList.sort()}
			printShow={printShow}
			paperSize={paperSize}
			writePrintNum={handlePrintNum}
		/>
	);
}

export default Print;
